import { render, staticRenderFns } from "./user-like.vue?vue&type=template&id=226ce8b7"
import script from "./user-like.vue?vue&type=script&lang=js"
export * from "./user-like.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports